import { Injectable } from '@angular/core';
import { UserService } from '../../../api/services/user.service';
import { AccountService } from '../../../api/services/account.service';
import { PreferencesService } from '../../../api/services/preferences.service';
import { Organization } from '../../../api/models/organization';

@Injectable()
export class ClientEditService {

  constructor(private userService: UserService,
    private accountService: AccountService,
    private preferencesService: PreferencesService,
  ) { }

  findClientByOrganizationId(uuid: string) {
    return this.userService.findOrganizationById(uuid);
  }

  saveLogo(orgId: string, fileId: string) {
    return this.preferencesService
    .setPreference('CUSTOMER', orgId, 'organization-logo', {Value: fileId});
  }

  deleteLogo(orgId: string) {
    return this.preferencesService.deletePreference('CUSTOMER', orgId, 'organization-logo');
  }

  saveTheme(orgId: string, theme: string) {
    return this.preferencesService
    .setPreference('CUSTOMER', orgId, 'theme-color', {Value: theme});
  }

  getPreferences(orgId: string) {
    return this.preferencesService.getPreferences('CUSTOMER', orgId);
  }

  saveClient(client: Organization) {
    return this.userService.saveOrganization(client);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/client-edit/client-edit.service.ts